import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <section
          style={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "120px 28px 80px",
          }}
        >
          <div style={{ textAlign: "center", maxWidth: 480 }}>
            <div
              style={{
                fontFamily: "var(--font-display)",
                fontSize: 48,
                color: "var(--color-accent)",
                marginBottom: 16,
              }}
            >
              Oops
            </div>
            <p
              style={{
                fontFamily: "var(--font-body)",
                fontSize: 16,
                color: "var(--text-subtle)",
                lineHeight: 1.7,
                marginBottom: 28,
              }}
            >
              Algo salió mal. Intenta recargar la página.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "12px 32px",
                borderRadius: 10,
                background:
                  "linear-gradient(135deg, var(--color-accent), var(--color-accent-dark))",
                border: "none",
                fontFamily: "var(--font-body)",
                fontSize: 14,
                fontWeight: 700,
                color: "#080810",
                cursor: "pointer",
              }}
            >
              Recargar
            </button>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}
